module.exports = angular.module('cartographer.chart.histogram', [])

$ = require 'jquery'
_ = require 'underscore'

module.exports.factory 'crtHistogramDefaults', $DI ->
  return {
    stackSeries    : true
    seriesDefaults :
      renderer        : $.jqplot.BarRenderer
      shadow          : false
      rendererOptions :
        barMargin          : 4
        highlightMouseOver : false
        highlightMouseDown : false
        highlightColor     : null
    series: [
      { color: "#dddddd" }
      { color: "#5bc0de" }
    ]
    axes:
      xaxis:
        renderer     : $.jqplot.CategoryAxisRenderer
        tickRenderer : $.jqplot.CanvasAxisTickRenderer
        ticks        : []
        tickOptions  :
          # textColor     : '#fff'
          fontSize      : '8px'
          pt2px         : 2.0
          labelPosition : 'middle'
          angle         : -30
      yaxis:
        min          : 0
        tickRenderer : $.jqplot.CanvasAxisTickRenderer
        tickOptions  :
          # textColor     : '#fff'
          fontSize      : '8px'
          pt2px         : 2.0
    grid:
      shadow          : false
      drawGridLines   : false
      showGridLines   : false
      renderGridLines : false
      gridLineColor   : "#ffffff"
      background      : "#ffffff" # IE8 doesn't like "transparent"
      borderColor     : "#cccccc"
      borderWidth     : 1
  }

module.exports.directive 'crtHistogram', $DI (crtLog, $timeout, crtHistogramDefaults) ->
  return {
    restrict    : 'A'
    scope       :
      buckets        : '='  # crtAttributeBuckets
      features       : '='  # arrayOf(feature)
      feature        : '=?' # or(feature, undefined) # selected feature
    controller: $DI ($scope) ->
      $scope.options ?= {}
      $scope.options = _.defaults($scope.options, crtHistogramDefaults)
      return
    link: ($scope, element, attrs) ->

      # jqPlot requires an element with a unique ID:
      elementId = attrs.id ? "histogram-#{$scope.$id}"

      calcDimensions = ->
        return {
          width  : element.parent().innerWidth() * 1.0 + 'px'
          height : element.parent().innerWidth() * 0.6 + 'px'
        }

      updateHistogram = ->
        element.html('').css(calcDimensions())

        crtLog.debug('crtHistogram.updateHistogram', $scope)

        if $scope.buckets.buckets.length > 1
          $scope.options.axes.xaxis.ticks =
            _.map($scope.buckets.buckets, (bucket) -> bucket.label)

          barHeights  = _.map($scope.buckets.buckets, (bucket) -> 0)
          selectedBar = -1

          for feature in $scope.features
            value = $scope.buckets.value(feature)
            for bucket, bucketIndex in $scope.buckets.buckets
              if bucket.contains(value)
                if feature == $scope.feature then selectedBar = bucketIndex
                barHeights[bucketIndex]++

          $scope.series = [
            _.map(barHeights, (height, index) -> if index == selectedBar then 0 else height)
            _.map(barHeights, (height, index) -> if index == selectedBar then height else 0)
          ]

          # crtLog.debug('crtHistogram.link.updateHistogram', elementId, $scope.series, $scope.options)

          $scope.chart?.destroy()

          if $scope.series.length > 0
            $scope.chart = $.jqplot(elementId, $scope.series, $scope.options)
        else
          $scope.chart?.destroy()
          $scope.chart = null

        return

      element.
        attr('id', elementId).
        addClass('chart chart-histogram').
        css(calcDimensions())

      $scope.$watchCollection('buckets',  -> $timeout(updateHistogram, 50))
      $scope.$watchCollection('features', -> $timeout(updateHistogram, 50))
      $scope.$watchCollection('feature',  -> $timeout(updateHistogram, 50))

      $scope.$on('chart:replot', -> $timeout(updateHistogram, 50))
      $scope.$on('chart:update', -> $timeout(updateHistogram, 50))

      return
  }
